<template>
  <el-dialog
    title="Fund your wallet"
    :visible.sync="shouldShow"
    @close="closeEvent"
    width="30%"
  >
    <el-form :model="form" label-position="top" ref="fund">
      <el-row type="flex">
        <el-col :span="24">
          <el-form-item
            v-custom-input="form.amount"
            class="ra-input mb-0"
            label="Amount"
            prop="amount"
            :rules="inputField()"
          >
            <el-input v-model.number="form.amount" v-only-number />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button :loading="loading" type="primary" @click="fund"
        >Fund</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { currentUser } from "@/lib/utils";
import apiConstants from "@/apiConstants.js";

export default {
  name: "FundWallet",
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentUser: currentUser(),
      loading: false,
      form: {
        amount: null
      },
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },
  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },
  methods: {
    fund() {
      this.$refs.fund.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.loading = true;
        const body = {
          entity_type_id: apiConstants.ENTITY_TYPE_ID,
          payment_method_id: apiConstants.PAYMENT_METHOD_ID,
          amount: Number(this.form.amount),
          contact_email: this.currentUser.email
        };
        this.$http
          .post(
            "payments/init",
            {
              body: body,
              method: "POST"
            },
            {
              headers: {
                "data-baseurl-namespace": apiConstants.URLS.PAYMENT
              }
            }
          )
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.loading = false;
              this.handleErrors(resData);
            } else {
              this.loading = false;
              window.open(resData.payment_url, "_self");
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },

    closeEvent() {
      this.shouldShow = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.title {
  color: #140508;
  font-weight: 500;
}
</style>
